export enum ResizeMode {
    X, Y, WIDTH, HEIGHT
}

export const TransformHandle = {
    nw: {
        modes: [ResizeMode.X, ResizeMode.Y],
        cursor: 'nw-resize'
    },
    n: {
        modes: [ResizeMode.Y],
        cursor: 'n-resize'
    },
    ne: {
        modes: [ResizeMode.WIDTH, ResizeMode.Y],
        cursor: 'ne-resize'
    },
    e: {
        modes: [ResizeMode.WIDTH],
        cursor: 'e-resize'
    },
    se: {
        modes: [ResizeMode.WIDTH, ResizeMode.HEIGHT],
        cursor: 'se-resize'
    },
    s: {
        modes: [ResizeMode.HEIGHT],
        cursor: 's-resize'
    },
    sw: {
        modes: [ResizeMode.HEIGHT, ResizeMode.X],
        cursor: 'sw-resize'
    },
    w: {
        modes: [ResizeMode.X],
        cursor: 'w-resize'
    }
}